import React from 'react';
import styled from 'styled-components';

import { Text } from '../atom/Text';

/** 테이블 리스트 컴포넌트 */
export const Table = ({
  header = [],
  body = [],
  headColor = 'rgba(255, 100, 82, 0.2)',
}) => {
  return (
    <TableContainer>
      <TableHead color={headColor}>
        <tr>
          {header.map((item) => (
            <TableHeadData key={item}>
              <Text weight="medium" size={14}>
                {item}
              </Text>
            </TableHeadData>
          ))}
        </tr>
      </TableHead>
      <tbody>
        {body.map((bodyItem, idx) => (
          <tr key={idx}>
            {bodyItem.map((item, idx) => (
              <TableBodyData key={idx}>
                <Text size={14}>{item}</Text>
              </TableBodyData>
            ))}
          </tr>
        ))}
      </tbody>
    </TableContainer>
  );
};

const TableContainer = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
`;

const TableHead = styled.thead`
  background: ${(props) => props.color};
`;

const TableHeadData = styled.th`
  text-align: ${(props) => props.textAlign || 'center'};
  padding-top: ${(props) => props.paddingTop || '0.75rem'};
  padding-bottom: ${(props) => props.paddingBottom || '0.75rem'};
  width: 1;
`;

const TableBodyData = styled.td`
  text-align: ${(props) => props.textAlign || 'center'};
  padding: 0.625rem 0;
`;
